import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const ServiceCard = ({ title, description, image, to, cta = "Service Details" }) => (
  <Card
    sx={{
      height: "100%",
      border: "1px solid var(--color-border)",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      background:
        "linear-gradient(180deg, rgba(255,255,255,0.98), rgba(252,248,242,0.96))",
      transition:
        "transform 0.24s ease, box-shadow 0.24s ease, border-color 0.24s ease",
      "&:hover": {
        transform: "translateY(-6px)",
        boxShadow: "var(--shadow-soft)",
        borderColor: "rgba(183, 132, 69, 0.24)",
      },
    }}
  >
    <Box
      sx={{
        aspectRatio: "16 / 10",
        backgroundImage: `linear-gradient(180deg, rgba(10, 18, 30, 0.04), rgba(10, 18, 30, 0.7)), url(${image})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        position: "relative",
        "&::after": {
          content: '""',
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, rgba(255,255,255,0), rgba(10,18,30,0.12) 48%, rgba(10,18,30,0.32) 100%)",
        },
      }}
    />
    <CardContent
      sx={{
        p: { xs: 2.85, md: 3.3 },
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
      }}
    >
      <Chip
        label="Service Line"
        size="small"
        sx={{
          mb: 2,
          alignSelf: "flex-start",
          bgcolor: "rgba(183, 132, 69, 0.11)",
          color: "primary.dark",
        }}
      />
      <Typography variant="h5" sx={{ mb: 1.25, maxWidth: "14ch" }}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ flexGrow: 1 }}>
        {description}
      </Typography>
      {to ? (
        <Button
          component={RouterLink}
          to={to}
          sx={{
            mt: 2.5,
            alignSelf: "flex-start",
            px: 0,
            minHeight: "auto",
            color: "secondary.main",
          }}
        >
          {cta}
        </Button>
      ) : null}
    </CardContent>
  </Card>
);

export default ServiceCard;
